import React, { useState } from 'react';
import { Typography, Box, Button, Grid, useMediaQuery, useTheme } from '@material-ui/core';
import { useIntl } from 'react-intl';
import { StepData } from './types';
import { StepButtonBar } from './StepButtonBar';
import EvaluationStepInfo from './EvaluationStepInfo';

const PRIMARY = '#c4122f';

interface StepSelectFlowProps {
  onBack: () => void;
  onCancel: () => void;
  isFirstStep: boolean;
  currentData: StepData;
  currentStepName: any;
  evalutionStepInfo: any;
  onUpdateEvalution?: (data: any) => void;
  onNext: (flow: 'create' | 'from-completed') => void;
}

const StepSelectFlow = ({
  onBack,
  onCancel,
  isFirstStep,
  currentData,
  onNext,
  evalutionStepInfo,
  currentStepName,
  onUpdateEvalution,
}: StepSelectFlowProps) => {
  const { formatMessage } = useIntl();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [selected, setSelected] = useState<'create' | 'from-completed' | null>(
    currentData._resolvedFlow ?? null,
  );

  const options: { id: 'create' | 'from-completed'; labelId: string; defaultLabel: string }[] = [
    {
      id: 'create',
      labelId: 'law-portal.legal.compliance.sub-menu.planning.create.plan',
      defaultLabel: 'Create',
    },
    {
      id: 'from-completed',
      labelId: 'law-portal.legal.compliance.sub-menu.planning.earlier.completed.plan',
      defaultLabel: 'Copy',
    },
  ];

  const paperPadding = isMobile ? theme.spacing(3) : theme.spacing(8);

  return (
    <div style={{ width: '100%' }}>
      <div
        style={{
          display: 'flex',
          width: '100%',
          gap: '10px',
          flexDirection: isMobile ? 'column' : 'row',
          alignItems: 'stretch',
        }}
      >
        <div
          style={{
            width: isMobile ? '100%' : 'calc(50% - 5px)',
            flexShrink: 0,
            padding: paperPadding,
            backgroundColor: '#f7f0f1',
            display: 'flex',
            flexDirection: 'column',
            boxSizing: 'border-box',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          {/* <Typography
            variant="h6"
            style={{
              fontWeight: 600,
              marginBottom: theme.spacing(5),
              lineHeight: 1.4,
              textAlign: 'center',
              fontSize: isMobile ? '16px' : '18px',
            }}
          >
            {formatMessage({
              id: 'law-portal.evalution.plan.select.flow.title',
              defaultMessage: 'How would you like to create the plan?',
            })}
          </Typography> */}

          <Box style={{ maxWidth: '320px', width: '100%' }}>
            <Grid container spacing={3} justifyContent="flex-start">
              {options.map(opt => (
                <Grid
                  item
                  key={opt.id}
                  xs={12}
                  style={{ display: 'flex', justifyContent: 'center' }}
                >
                  <Button
                    variant="outlined"
                    onClick={() => setSelected(opt.id)}
                    style={{
                      padding: isMobile ? '18px 24px' : '22px 32px',
                      fontSize: isMobile ? '14px' : '16px',
                      fontWeight: 700,
                      color: selected === opt.id ? '#fff' : PRIMARY,
                      background: selected === opt.id ? PRIMARY : 'transparent',
                      width: '100%',
                      maxWidth: '260px',
                      borderRadius: '8px',
                      textTransform: 'uppercase',
                      letterSpacing: '0.5px',
                      transition: 'all 0.2s ease',
                      border: `2px solid ${PRIMARY}`,
                    }}
                  >
                    {formatMessage({ id: opt.labelId, defaultMessage: opt.defaultLabel })}
                  </Button>
                </Grid>
              ))}
            </Grid>
          </Box>
        </div>

        <EvaluationStepInfo evalutionStepInfo={evalutionStepInfo} currentStepName={currentStepName} onUpdate={onUpdateEvalution} />
      </div>

      <Box>
        <StepButtonBar
          onCancel={onCancel}
          onBack={onBack}
          onNext={() => { if (selected) onNext(selected); }}
          nextLabel="form.save.and.back"
          nextDisabled={!selected}
          showBack={!isFirstStep}
          formatMessage={formatMessage}
        />
      </Box>
    </div>
  );
};

export default StepSelectFlow;